var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"mb-12 text-center"},[_c('h1',{staticClass:"font-weight-light mb-2 headline",domProps:{"textContent":_vm._s(`${_vm.heading}`)}}),_vm._t("body",null,{"item":_vm.item})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }